/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Router from 'vue-router'
import AutoLogin from '@/middleware/autoLogin.js'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior () {
    return { x: 0, y: 0 }
  },
  routes: [

    {
    // =============================================================================
    // MAIN LAYOUT ROUTES
    // =============================================================================
      path: '',
      component: () => import('./layouts/main/Main.vue'),
      beforeEnter: AutoLogin,
      children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
        {
          path: '/',
          name: 'home',
          component: () => import('./views/Home.vue')
        },
        {
          path: '/page2',
          name: 'page-2',
          component: () => import('./views/Page2.vue')
        },
        {
          path: '/pages/manage-nimble/users',
          name: 'manage-nimble',
          component: () => import('@/views/pages/manage-nimble/ManageNimbleUsers.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Pages' },
              { title: 'Manage Nimble', active: true }
            ],
            pageTitle: 'Manage Nimble',
            rule: 'editor'
          }
        },
        {
          path: '/pages/hr-people',
          name: 'hr-people',
          component: () => import('@/views/pages/hr-people/StaffRecord.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Pages' },
              { title: 'HR & People', active: true }
            ],
            pageTitle: 'HR & People',
            rule: 'editor'
          }
        },
        {
          path: '/pages/user-settings',
          name: 'page-user-settings',
          component: () => import('@/views/pages/user-settings/UserSettings.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Pages' },
              { title: 'User Settings', active: true }
            ],
            pageTitle: 'Settings',
            rule: 'editor'
          }
        },
        {
          path: '/pages/supplier-user',
          name: 'page-supplier-user',
          component: () => import('@/views/pages/supplier-manage/ManageSupplierUser.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'User List', active: true }
            ],
            pageTitle: 'Customer Users',
            rule: 'editor'
          }
        },
        {
          path: '/pages/customer-sites',
          name: 'page-customer-sites',
          component: () => import('@/views/pages/supplier-manage/ManageCustomerSites.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Sites List', active: true }
            ],
            pageTitle: 'Customer Sites',
            rule: 'editor'
          }
        },
        {
          path: '/pages/customer-profile',
          name: 'page-customer-profile',
          component: () => import('@/views/pages/supplier-manage/SupplierProfile.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Customer Profile', active: true }
            ],
            pageTitle: 'Customer Profile',
            rule: 'editor'
          }
        },
        {
          path: '/pages/customer-project-briefs',
          name: 'page-project-briefs',
          component: () => import('@/views/pages/supplier-manage/CustomerProjectBriefList.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Project Brief', active: true }
            ],
            pageTitle: 'Project Brief',
            rule: 'editor'
          }
        },
        {
          path: '/pages/customer-account-credit',
          name: 'page-account-credit',
          component: () => import('@/views/pages/supplier-manage/AccountCreditHome.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Account Credit', active: true }
            ],
            pageTitle: 'Account Credit',
            rule: 'editor'
          }
        },
        {
          path: '/pages/customer-sample-orders',
          name: 'page-sample-orders',
          component: () => import('@/views/pages/supplier-manage/sample-orders/CustomerSampleOrdersList.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Sample Orders', active: true }
            ],
            pageTitle: 'Sample Orders',
            rule: 'editor'
          }
        },
        {
          path: '/pages/customer-product-contracts',
          name: 'page-product-contracts',
          component: () => import('@/views/pages/supplier-manage/product-contratcs/CustomerProductContracts.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Product Contracts', active: true }
            ],
            pageTitle: 'Manage Product Contracts',
            rule: 'editor'
          }
        },
        {
          path: '/pages/customer-product-orders',
          name: 'page-product-orders',
          component: () => import('@/views/pages/supplier-manage/product-orders/CustomerProductOrdersList.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Product Orders', active: true }
            ],
            pageTitle: 'Manage Product Orders',
            rule: 'editor'
          }
        },
        {
          path: '/pages/customer-product-orders/:id',
          name: 'page-product-orders-view',
          component: () => import('@/views/pages/supplier-manage/product-orders/ProductOrderDetailsView.vue'),
          meta: {
            parent: 'page-product-orders',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Product Order View', active: true }
            ],
            pageTitle: 'Product Order View',
            rule: 'editor'
          }
        },
        {
          path: '/pages/product-catalogue',
          name: 'product-catalogue',
          component: () => import('@/views/pages/product-catalogue/ProductCatalogueList.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Product Catalogue', active: true }
            ],
            pageTitle: 'View Product Catalogue',
            rule: 'editor'
          }
        },
        {
          path: '/pages/sales-quotes',
          name: 'sales-quotes',
          component: () => import('@/views/pages/sales-quote/SalesQuotationList.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Sales Quotation', active: true }
            ],
            pageTitle: 'Sales Quotation',
            rule: 'editor'
          }
        },
        {
          path: '/pages/credit-notes',
          name: 'credit-notes',
          component: () => import('@/views/pages/credit-note/CreditNoteList.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Credit Note', active: true }
            ],
            pageTitle: 'Credit Note',
            rule: 'editor'
          }
        },
        {
          path: '/pages/invoices',
          name: 'invoice-manage',
          component: () => import('@/views/pages/invoice-manage/InvoiceList.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Invoice Manage', active: true }
            ],
            pageTitle: 'Invoice Manage',
            rule: 'editor'
          }
        },
        {
          path: '/pages/supplier-manufacturing',
          name: 'supplier-manufacturing',
          component: () => import('@/views/pages/supplier-manage/ManufacturingManage.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Manufacturing Sites', active: true }
            ],
            pageTitle: 'Manufacturing Sites',
            rule: 'editor'
          }
        },
        {
          path: '/pages/supplier-manufacturing/create',
          name: 'supplier-manufacturing-create',
          component: () => import('@/views/pages/supplier-manage/manage-manufacturing-create/ManufactureDetailsView.vue'),
          meta: {
            parent: 'supplier-manufacturing',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Manufacturing Sites', url: '/pages/supplier-manufacturing' },
              { title: 'Create', active: true }
            ],
            pageTitle: 'Manufacturing Site Create',
            rule: 'editor'
          }
        },
        {
          path: '/pages/supplier-manufacturing/:id',
          name: 'supplier-manufacturing-view',
          component: () => import('@/views/pages/supplier-manage/manage-manufacturing/ManufactureDetailsView.vue'),
          meta: {
            parent: 'supplier-manufacturing',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Manufacturing Sites', url: '/pages/supplier-manufacturing' },
              { title: 'Supplier Manufacturing Details', active: true }
            ],
            pageTitle: 'Manufacturing Site Details',
            rule: 'editor'
          }
        },
        {
          path: '/pages/supplier-manufacturing-create',
          name: 'manufacturing-create',
          component: () => import('@/views/SupplierForm.vue'),
          meta: {
            parent: 'supplier-manufacturing',
            // pageTitle: 'Create Manufacturing Form',
            rule: 'editor'
          }
        },
      ]
    },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: '',
      component: () => import('@/layouts/full-page/FullPage.vue'),
      redirect: '/page/login',
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        {
          path: '/pages/login',
          name: 'page-login',
          component: () => import('@/views/pages/Login.vue')
        },
        {
          path: '/pages/forgot-password',
          name: 'page-forgot-password',
          component: () => import('@/views/pages/ForgotPassword.vue')
        },
        {
          path: '/pages/reset-password/:token',
          name: 'page-reset-password',
          component: () => import('@/views/pages/ResetPassword.vue')
        },
        {
          path: '/pages/email-verification/:code',
          name: 'page-verification',
          component: () => import('@/views/pages/EmailVerification.vue')
        },
        {
          path: '/pages/error-404',
          name: 'page-error-404',
          component: () => import('@/views/pages/Error404.vue')
        },
        {
          path: '/pages/customer-2fa',
          name: 'page-2fa',
          beforeEnter: AutoLogin,
          component: () => import('@/views/pages/Customer2FA.vue')
        },
        {
          path: '/files/sale_quote/:key',
          name: 'public-sales-quote',
          beforeEnter: AutoLogin,
          component: () => import('@/views/pages/sales-quote/SalesQuotePrintView.vue')
        },
        {
          path: '/files/credit_note/:key',
          name: 'credit-note',
          beforeEnter: AutoLogin,
          component: () => import('@/views/pages/credit-note/CreditNotePrintView.vue')
        },
        {
          path: '/files/invoice/:key',
          name: 'invoice-note',
          beforeEnter: AutoLogin,
          component: () => import('@/views/pages/invoice-manage/InvoicePrintView.vue')
        },
        {
          path: '/files/shipment/:key',
          name: 'shipment-note',
          beforeEnter: AutoLogin,
          component: () => import('@/views/pages/shipments/DeliveryNotePrintView.vue')
        },
      ]
    },
    // Redirect to 404 page, if no match found
    {
      path: '*',
      redirect: '/pages/error-404'
    }
  ]
})

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
